import { Progress } from "@/ui/components/ui/progress";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

const MachinesLiveSkeleton = () => {
  const { t } = useTranslation("machines");

  return (
    <div className="w-full h-full flex flex-col">
      <div className="flex items-center justify-center px-4 py-2 bg-muted/50 rounded-lg mb-4">
        <div className="flex items-center gap-3 text-xs text-muted-foreground">
          <Loader2 className="h-4 w-4 animate-spin text-primary" />
          <span>{t("live.loadingChart")}</span>
        </div>
      </div>

      <div className="flex-1 flex flex-col items-center justify-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <div className="text-center space-y-2">
          <p className="text-sm font-medium">{t("live.loadingData")}</p>
          <div className="w-64 max-w-full">
            <Progress value={45} className="h-2" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MachinesLiveSkeleton;
